import { render } from "./TransactionModal.vue?vue&type=template&id=0bf46eb9&scoped=true"
import script from "./TransactionModal.vue?vue&type=script&lang=js"
export * from "./TransactionModal.vue?vue&type=script&lang=js"

import "./TransactionModal.vue?vue&type=style&index=0&id=0bf46eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf46eb9"]])

export default __exports__